import { forEach, isElement } from 'lodash';
import mustache from 'mustache';

import { get as getPageOptions } from '../../01-helpers/utilities/options';

import getPlaces from '../../03-api/autocomplete/get-places';

import Autocomplete from '../../04-components/autocomplete/';

const moduleName = 'places',
	selectors = {
		base: `.js-autocomplete-${moduleName}`,
		northeast: `.js-autocomplete-northeast`,
		southwest: `.js-autocomplete-southwest`
    },
	translationsKey = {
		key: 'translations'
	},
	templateCityList = `
        {{#cities}}
            <li>
				<button class="c-search-box__result js-autocomplete-list-item" data-autocomplete='{"boundingBox": [{{ BoundingBox.NorthEast.Latitude }},{{ BoundingBox.NorthEast.Longitude }},{{ BoundingBox.SouthWest.Latitude }},{{ BoundingBox.SouthWest.Longitude }}], "center": [{{ Center.Latitude }},{{ Center.Longitude }}]}' type="button">{{ Name }} - {{ FullName }}</button>
			</li>
        {{/cities}}
	`;

export class PlaceSearch extends Autocomplete {

	constructor(baseElement) {
		super(baseElement);

		this.northeast = baseElement.querySelector(selectors.northeast);
		this.southwest = baseElement.querySelector(selectors.southwest);
		this.translations = getPageOptions(translationsKey.key);
	}

	renderTemplate(data) {
		const
			cities = {
				"cities": data,
			},
			htmlTemplate = mustache.render(templateCityList, cities);

		return  htmlTemplate;
	}

	resetFilter() {
		this.filterContext.update(
			{
				SearchQuery: "",
				SearchBox: null
			},
			{ refresh: true }
		);
	}

	/*================ EVENT HANDLERS ===============*/

	/**
	 * Handler for Click event on ListItem
	 *
	 * @param {any} evt - Click (Mouse) event
	 */
	_onItemClickHandler(evt) {
		const target = evt.currentTarget || evt.target,
			dataset = JSON.parse(target?.dataset?.autocomplete);

		this.input.value = target.innerText;

		if (isElement(this.northeast) || isElement(this.southwest)) {
			this.northeast.value = `${dataset.boundingBox[0]},${dataset.boundingBox[1]}`;
			this.southwest.value = `${dataset.boundingBox[2]},${dataset.boundingBox[3]}`;
        }

		this.filterContext.update(
			{
				SearchQuery: this.input.value,
				SearchBox: {
					NorthEast: {
						Latitude: dataset.boundingBox[0],
						Longitude: dataset.boundingBox[1]
					},
					SouthWest: {
						Latitude: dataset.boundingBox[2],
						Longitude: dataset.boundingBox[3]
					}
				},
				Center: {
					Latitude: dataset.center[0],
					Longitude: dataset.center[1]
				},
				NodeId: this.NodeId,
				Page: this.Page
			},
			{ refresh: true }
		);

		this.input.dataset.autofill = true;
		// close the container after a selection is made
		this.closeContainer();
	}

	_onKeyUpHandler(evt) {
		this.input.dataset.autofill = false;
		const element = evt.target,
			value = element.value;

		if (value.length >= 3) {
			const data = {
				query: value
			};

			// call getPlaces API
			getPlaces(data)
				.done(results => {
					this.list.innerHTML = '';
					
					this.list.innerHTML = this.renderTemplate(results);
					this._setClickEvent(this.list);
				})
				.fail(error => {
					console.error(this.translations[translationsKey.CityCourseError]);
				});
		}
		else if (value.length == 0) {
			this.resetFilter();
		}
	}
}

const initPlaceSearch = () => {
	forEach(document.querySelectorAll(selectors.base), (baseElement) => {
		new PlaceSearch(baseElement);
	});
};

initPlaceSearch();